const disableMediaContextMenu = true;

// Start da in sv
function dainsv() {

    let daCookie = getCookie("dainsv");

    if(daCookie !== null) {
        //then user has set a value
        if(daCookie == 'stay') {
            return; // do nothing dk user wants stay in sv
        }
        if(daCookie == 'redirect') {
            window.location = "https://callisto-jewellery.dk" + window.location.pathname;
            return;
        }
    }
    else {
        fetch('/browsing_context_suggestions.json')
        .then(response => response.json())
        .then(data => {
            //const countryName = data.detected_values.country.name;
            const countryCode = data.detected_values.country.handle;
            //console.log('Detected Country:', countryName, countryCode);
            if(countryCode == "DK") {
                popupRedirecter();
            }
        });

    }
}

function popupRedirecter() {
    const el1 = document.createElement('div');
    el1.className = 'da-se-wrapper';

    const el2 = document.createElement('div');
    el2.className = 'msg-box';   

    const el3 = document.createElement('div');
    el3.className = 'msg-box-head';
    el3.innerHTML = 'Det ser ud til,<br>at du er i Danmark';

    const el4 = document.createElement('div');
    el4.className = 'msg-box-text';
    el4.innerHTML = 'Ønsker du at handle på den danske webshop<br>med danske priser og levering?';

    const el5 = document.createElement('div');
    el5.className = 'dk-button';
    el5.setAttribute('onclick', 'daRedirect(1)');
    el5.innerHTML = 'GÅ TIL DEN DANSKE WEBSHOP';

    const el6 = document.createElement('div');
    el6.className = 'sv-button';
    el6.setAttribute('onclick', 'daRedirect(0)');
    el6.innerHTML = 'BLIV PÅ DEN SVENSKE WEBSHOP';

    const el7 = document.createElement('div');
    el7.className = 'msg-box-foot';
    el7.innerHTML = 'Dit valg gemmes i 90 dage';    

    const el8 = document.createElement('span');
    el8.className = 'msg-box-close';
    el8.innerHTML = 'X';  
    el8.setAttribute('onclick', 'daRedirect(9)');

    el2.appendChild(el3);
    el2.appendChild(el4);
    el2.appendChild(el5);
    el2.appendChild(el6);
    el2.appendChild(el7);
    el2.appendChild(el8);
    el1.appendChild(el2);
    document.body.prepend(el1);
}

function daRedirect(answer) {
    if(answer == 9){
        //user clicked on close -> will popup on next pageload
        document.querySelector('.da-se-wrapper').style.display = 'none';
        return;
    }
    if(answer == 1) {
        setCookie('dainsv', 'redirect', 90);
        window.location = "https://callisto-jewellery.dk" + window.location.pathname;
    }
    else {
        //user wants to stay even if user is based in DK
        setCookie('dainsv', 'stay', 90);
        document.querySelector('.da-se-wrapper').style.display = 'none';
    }
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

function cookieExists(name) {
  return document.cookie.split(';').some(item => 
    item.trim().startsWith(`${name}=`)
  );
}
dainsv();
// End da in sv

function isMobile(){
    return window.matchMedia("(max-width: 959px)").matches;
}

function onProductPage(){
    return  document.body.classList.contains("template-product");
}

document.addEventListener("DOMContentLoaded", (event) => { 

   handleMedia();
});

function handleMedia(){
    const videos = document.querySelectorAll('video');
    const imgs = document.querySelectorAll('img');

    if(disableMediaContextMenu){
        imgs.forEach(img => {
            img.setAttribute('oncontextmenu', "return true;");
        });
    }

    if(onProductPage()){   
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                entry.target.onpause = function(){ //after first view it pauses even if visible - so therefor this function
                    if(entry.isIntersecting){ //console.log("Subsequent play")
                        entry.target.play();
                    }
                }
                if (entry.isIntersecting) { //console.log("Play");
                    entry.target.play();
                } else {
                    entry.target.pause(); //console.log("Pause");
                }
            });
        });
        videos.forEach(video => {
            observer.observe(video);
            if(disableMediaContextMenu){
                video.setAttribute('oncontextmenu', "return false;");
            }
        });
    }
}
